import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';

import { getProducts,createCoa , getCoa,select,getCreatedBy} from './reducers/productReducer';
import { usertReducers } from './reducers/userReducer';


const reducer = combineReducers({
  

  getProducts,
  createCoa, 
  getCoa,
  select,
  user:usertReducers,
  created:getCreatedBy
});

let intitialeState = {
    
}; 

const middleware = [thunk]

const store = createStore(
    reducer,
    intitialeState,
    composeWithDevTools(applyMiddleware(...middleware))
)

export default store;
